var commonData={
    statusOptions:[//待处理订单状态枚举
      {
        value:'-2',
        text:'待完善'
      },
      {
        value:'-1',
        text:'已取消'
      },
      {
        value:'0',
        text:'待支付'
      },
      {
        value:'17',
        text:'待支付'
      },
      {
        value:'1',
        text:'投保成功'
      },
      {
        value:'2',
        text:'已退保'
      },
      {
        value:'3',
        text:'订单已支付投保失败'
      },
      {
        value:'11',
        text:'核保中'
      },
      {
        value:'32',
        text:'核保中'
      },
      {
        value:'14',
        text:'核保失败'
      },
      {
        value:'15',
        text:'核保失败'
      },
    ],
    idTypeOptions:[
      {
        value:'01',
        text:'身份证'
      },
      {
        value:'1',
        text:'身份证'
      },
      {
        value:'2',
        text:'护照'
      },
      {
        value:'02',
        text:'护照'
      },
      {
        value:'3',
        text:'军人证'
      },
      {
        value:'03',
        text:'军人证'
      },
      {
        value:'4',
        text:'港澳通行证'
      },
      {
        value:'04',
        text:'港澳通行证'
      },
      {
        value:'5',
        text:'驾驶证'
      },
      {
        value:'05',
        text:'驾驶证'
      },
      {
        value:'6',
        text:'港澳回乡证或台胞证'
      },
      {
        value:'06',
        text:'港澳回乡证或台胞证'
      },
      {
        value:'7',
        text:'临时身份证'
      },
      {
        value:'07',
        text:'临时身份证'
      },
      {
        value:'8',
        text:'出生证'
      },
      {
        value:'9',
        text:'户口本'
      },
      {
        value:'09',
        text:'户口本'
      },
      {
        value:'10',
        text:'外国护照'
      },
      {
        value:'11',
        text:'士兵证'
      },
      {
        value:'12',
        text:'台湾居民来往内地通行'
      },
      {
        value:'99',
        text:'其它'
      },
      {
        value:'110004',
        text:'统一社会信用代码证'
      },
      {
        value:'01',
        text:'组织机构代码证'
      },
    ],
    companyIdTypeOptions:[
      {
        value:'01',
        text:'组织机构代码证'
      },
      {
        value:'02',
        text:'税务登记证'
      },
      {
        value:'03',
        text:'统一社会信用代码证'
      },
      {
        value:'110004',
        text:'统一社会信用代码证'
      },
      {
        value:'04',
        text:'工商营业执照'
      },
      {
        value:'05',
        text:'统一社会信用代码（五证合一号码）'
      },
      {
        value:'06',
        text:'金融许可证号码'
      },
      {
        value:'07',
        text:'国家主管部门颁外国驻华机构批文号'
      },
      {
        value:'99',
        text:'其它'
      },
      {
        value:'100',
        text:'其他类境外机构代码'
      },
    ]
  }
  export default commonData;